const en = {
  hero: {
    title: 'Earn 30% recurring revenue with VGOT',
    subtitle: 'Share VGOT with your audience, clients or students and earn commissions every time they subscribe.',
    apply: 'Apply to become a partner',
    downloadGuide: 'Download partner guide',
    payouts: 'Payouts powered by Stripe. Transparent tracking and monthly payouts.',
  },
  intro: {
    heading: 'Join the VGOT Partner Program',
    subheading: 'Share VGOT with your community. Every paid subscription from your link earns you a 30% recurring commission via secure Stripe payouts.',
    cards: {
      highCommission: {
        title: 'High Recurring Commission',
        description: 'Not just the first sale. Earn 30% every month as long as your user keeps their subscription.',
      },
      stripeSettlement: {
        title: 'Stripe Automated Payouts',
        description: 'We handle Stripe Connect and send commissions directly to your bank account—transparent and hassle-free.',
      },
      marketingResources: {
        title: 'Exclusive Marketing Resources',
        description: 'Get official demo videos, banners and copy templates to boost your promotion and conversions.',
      },
    },
    cta: {
      title: 'Ready to start earning?',
      description: 'Tell us briefly about your audience. After you apply, our team reviews within 24 hours and sends a Stripe invitation.',
      applyButton: 'Apply as Partner',
      contactSupport: 'Contact Support',
    },
  },
  whoIsThisFor: {
    title: 'Perfect for creators, agencies and community leaders',
  creators: 'TikTok & social media creators teaching HyperSell or AI video',
    agencies: 'Agencies & MCNs managing multiple e-commerce stores',
    educators: 'Course creators & mentors running bootcamps or cohorts',
    communities: 'Community leaders with active Discord / WhatsApp / Telegram groups',
  },
  earning: {
    title: 'How you earn with the VGOT Partner Program',
    revenue: '30% revenue share on every Pro and Business subscription you refer',
    recurring: 'Recurring for up to 12 months of each customer\'s subscription',
    payouts: 'Payouts handled automatically via Stripe every month',
    dashboard: 'Real-time dashboard with clicks, trials, conversions and earnings',
    exampleTitle: 'Example earnings',
    example1: '10 Pro users × 10 × $29 × 30% = $87 / month',
    example2: '10 Business users × 10 × $99 × 30% = $297 / month',
    exampleTotal: 'Together, that\'s',
    exampleRecurring: 'per month in recurring income from just 20 active users',
  },
  tiers: {
    title: 'Contact Us',
    affiliate: {
      name: 'Affiliate Partner',
      price: '',
      description: 'Perfect for content creators and influencers who want to share VGOT with their audience.',
      cta: 'Apply as Affiliate Partner',
      features: [
        '30% revenue share on referred subscriptions',
        'Personal referral link',
        'Access to marketing materials (banners, sample scripts, demo videos)',
        'Email partner support',
        'Real-time tracking dashboard',
      ],
    },
    leader: {
      name: 'Leader Partner',
      price: 'Starting from $99',
      description: 'Premium tier for agencies, educators and community leaders with dedicated support.',
      cta: 'Apply as Leader',
      features: [
        'All Affiliate benefits',
        'Higher priority support & private partner channel',
        'Co-branded landing page and case studies',
        'Early access to new features and campaigns',
        'Joint webinars / live sessions with VGOT team',
        'Custom deals for top-performing partners',
      ],
    },
    customDeals: 'Custom deals and higher revenue share available for top partners.',
  },
  howItWorks: {
    title: 'How it works',
    step1: {
      title: 'Apply',
      description: 'Fill out a short form about your audience and use case.',
    },
    step2: {
      title: 'Get your partner link',
      description: 'Once approved, you\'ll receive your unique referral link and access to partner resources.',
    },
    step3: {
      title: 'Share & earn',
      description: 'Share VGOT with your community. Every paid subscription from your link earns you 30% recurring commission, paid out via Stripe.',
    },
  },
  whyPromote: {
    title: 'Why partners love promoting VGOT',
  highConverting: 'High-converting product: end-to-end workflow from scripts to HyperSell videos',
    clearPricing: 'Clear pricing and plans your audience understands',
    educationFriendly: 'Education-friendly: perfect for tutorials, workshops, and courses',
    global: 'Global: works for brands and creators across markets',
    realPartnership: 'Real partnership: we help you design challenges, launches, and campaigns',
    recurring: '30% recurring revenue: earn from renewals, not just first sale',
  },
  faq: {
    title: 'Partner FAQ',
    q1: {
      question: 'Do I need to pay to join?',
      answer: 'No. The standard Affiliate Partner tier is free. For advanced Leader Partners with extra support and co-marketing, we may charge a one-time onboarding fee.',
    },
    q2: {
      question: 'How long do I earn commissions from each customer?',
      answer: 'You earn 30% of their Pro or Business plan for up to 12 months from their first payment.',
    },
    q3: {
      question: 'How do payouts work?',
      answer: 'We use Stripe for automated payouts. Connect your Stripe account once, then receive monthly payouts as long as you have eligible commissions.',
    },
    q4: {
      question: 'Can I use VGOT myself and still be a partner?',
      answer: 'Absolutely. Many of our best partners are also heavy VGOT users.',
    },
    q5: {
      question: 'Is there a minimum payout threshold?',
      answer: 'You can set a minimum payout threshold in your partner dashboard (for example $50). Once you reach it, Stripe will process your payout automatically.',
    },
  },
};

const es = {
  hero: {
    title: 'Gana 30% de ingresos recurrentes con VGOT',
    subtitle: 'Comparte VGOT con tu audiencia, clientes o estudiantes y gana comisiones cada vez que se suscriban.',
    apply: 'Solicita ser socio',
    downloadGuide: 'Descargar guía de socios',
    payouts: 'Pagos con Stripe. Seguimiento transparente y pagos mensuales.',
  },
  intro: {
    heading: 'Únete al Programa de Socios de VGOT',
    subheading: 'Comparte VGOT con tu comunidad. Cada suscripción paga desde tu enlace te genera una comisión recurrente del 30% vía Stripe.',
    cards: {
      highCommission: {
        title: 'Comisión Recurrente Alta',
        description: 'No solo la primera venta. Gana 30% cada mes mientras el usuario mantenga su suscripción.',
      },
      stripeSettlement: {
        title: 'Pagos Automatizados Stripe',
        description: 'Gestionamos Stripe Connect y enviamos comisiones directo a tu banco con transparencia total.',
      },
      marketingResources: {
        title: 'Recursos de Marketing Exclusivos',
        description: 'Obtén videos demo oficiales, banners y plantillas de copy para aumentar tus conversiones.',
      },
    },
    cta: {
      title: '¿Listo para comenzar a ganar?',
      description: 'Cuéntanos brevemente sobre tu audiencia. Tras aplicar, revisamos en 24h y enviamos invitación Stripe.',
      applyButton: 'Aplicar como Socio',
      contactSupport: 'Contactar Soporte',
    },
  },
  whoIsThisFor: {
    title: 'Perfecto para creadores, agencias y líderes comunitarios',
  creators: 'Creadores de TikTok y redes sociales que enseñan HyperSell o video con IA',
    agencies: 'Agencias y MCNs que gestionan múltiples tiendas de e‑commerce',
    educators: 'Creadores de cursos y mentores que dirigen bootcamps o cohortes',
    communities: 'Líderes de comunidad con grupos activos en Discord / WhatsApp / Telegram',
  },
  earning: {
    title: 'Cómo ganas con el Programa de Socios de VGOT',
    revenue: '30% de participación en ingresos en cada suscripción Pro y Business que refieras',
    recurring: 'Recurrente por hasta 12 meses de la suscripción de cada cliente',
    payouts: 'Pagos manejados automáticamente a través de Stripe cada mes',
    dashboard: 'Panel en tiempo real con clics, pruebas, conversiones y ganancias',
    exampleTitle: 'Ganancias de ejemplo',
    example1: '10 usuarios Pro × 10 × $29 × 30% = $87 / mes',
    example2: '10 usuarios Business × 10 × $99 × 30% = $297 / mes',
    exampleTotal: 'En total, son',
    exampleRecurring: 'al mes en ingresos recurrentes con solo 20 usuarios activos',
  },
  tiers: {
    title: 'Contáctenos',
    affiliate: {
      name: 'Socio Afiliado',
      price: '',
      description: 'Perfecto para creadores de contenido e influencers que quieren compartir VGOT con su audiencia.',
      cta: 'Solicitar como Socio Afiliado',
      features: [
        '30% de participación en ingresos en suscripciones referidas',
        'Enlace de referencia personal',
        'Acceso a materiales de marketing (banners, guiones de muestra, videos de demostración)',
        'Soporte de socio por correo electrónico',
        'Panel de seguimiento en tiempo real',
      ],
    },
    leader: {
      name: 'Socio Líder',
      price: 'Desde $99',
      description: 'Nivel premium para agencias, educadores y líderes comunitarios con soporte dedicado.',
      cta: 'Solicitar como Líder',
      features: [
        'Todos los beneficios de Afiliado',
        'Soporte prioritario y canal privado para socios',
        'Página co‑brandeada y casos de estudio',
        'Acceso anticipado a nuevas funciones y campañas',
        'Webinars / sesiones en vivo con el equipo de VGOT',
        'Ofertas personalizadas para socios de alto rendimiento',
      ],
    },
    customDeals: 'Ofertas personalizadas y mayor participación en ingresos disponibles para socios destacados.',
  },
  howItWorks: {
    title: 'Cómo funciona',
    step1: {
      title: 'Solicitar',
      description: 'Completa un formulario corto sobre tu audiencia y caso de uso.',
    },
    step2: {
      title: 'Obtén tu enlace de socio',
      description: 'Una vez aprobado, recibirás tu enlace de referencia único y acceso a recursos para socios.',
    },
    step3: {
      title: 'Comparte y gana',
      description: 'Comparte VGOT con tu comunidad. Cada suscripción pagada desde tu enlace te genera una comisión recurrente del 30%, pagada a través de Stripe.',
    },
  },
  whyPromote: {
    title: 'Por qué a los socios les encanta promover VGOT',
  highConverting: 'Producto de alta conversión: flujo de trabajo de extremo a extremo desde guiones hasta videos HyperSell',
    clearPricing: 'Precios claros y planes comprensibles para tu audiencia',
    educationFriendly: 'Amigable con la educación: perfecto para tutoriales, talleres y cursos',
    global: 'Global: funciona para marcas y creadores en múltiples mercados',
    realPartnership: 'Asociación real: te ayudamos a diseñar retos, lanzamientos y campañas',
    recurring: '30% de ingresos recurrentes: gana con las renovaciones, no solo con la primera compra',
  },
  faq: {
    title: 'Preguntas frecuentes de socios',
    q1: {
      question: '¿Necesito pagar para unirme?',
      answer: 'No. El nivel estándar de Socio Afiliado es gratuito. Para Socios Líder con soporte adicional y co‑marketing, podemos cobrar una tarifa única de incorporación.',
    },
    q2: {
      question: '¿Cuánto tiempo gano comisiones de cada cliente?',
      answer: 'Ganas el 30% de su plan Pro o Business durante hasta 12 meses desde su primer pago.',
    },
    q3: {
      question: '¿Cómo funcionan los pagos?',
      answer: 'Usamos Stripe para pagos automáticos. Conecta tu cuenta de Stripe una vez, y recibirás pagos mensuales mientras tengas comisiones elegibles.',
    },
    q4: {
      question: '¿Puedo usar VGOT yo mismo y seguir siendo socio?',
      answer: 'Por supuesto. Muchos de nuestros mejores socios también son usuarios avanzados de VGOT.',
    },
    q5: {
      question: '¿Hay un umbral mínimo de pago?',
      answer: 'Puedes establecer un umbral mínimo de pago en tu panel de socio (por ejemplo $50). Una vez lo alcances, Stripe procesará tu pago automáticamente.',
    },
  },
};

// Chinese Simplified - spread English for untouched sections to avoid runtime undefined errors
const zhCN = {
  ...en,
  hero: {
    title: '推广 VGOT 获得 30% 循环分佣',
    subtitle: '向您的受众、客户或学员分享 VGOT，用户每次订阅您都可获得佣金。',
    apply: '申请成为合作伙伴',
    downloadGuide: '下载合作指南',
    payouts: 'Stripe 结算，透明跟踪，每月自动打款。',
  },
  intro: {
    heading: '加入 VGOT 合作伙伴计划',
    subheading: '与您的社区分享 VGOT。来自您链接的每个付费订阅都能为您赚取 30% 持续佣金，经由 Stripe 安全结算。',
    cards: {
      highCommission: {
        title: '高额持续分佣',
        description: '不止首次订阅。用户保持订阅的每一个月，您都可获得 30% 分成。',
      },
      stripeSettlement: {
        title: 'Stripe 自动结算',
        description: '我们为您处理 Stripe Connect，佣金直接转入您的银行账户，透明省心。',
      },
      marketingResources: {
        title: '专属营销资源',
        description: '获得官方演示视频、横幅与文案模板，轻松推广提升转化。',
      },
    },
    cta: {
      title: '准备好开始赚钱了吗？',
      description: '告诉我们您的受众类型。提交后 24 小时内审核并发送 Stripe 邀请。',
      applyButton: '申请成为合作伙伴',
      contactSupport: '联系支持团队',
    },
  },
  whoIsThisFor: {
    title: '非常适合创作者、机构与社区负责人',
    creators: '教授 HyperSell 或 AI 视频的 TikTok / 社交媒体创作者',
    agencies: '管理多家电商店铺的机构与 MCN',
    educators: '运营训练营或系列课程的课程创作者与导师',
    communities: '拥有活跃 Discord / WhatsApp / Telegram 社群的社区负责人',
  },
  earning: {
    title: '您在 VGOT 合作伙伴计划中的收益方式',
    revenue: '每个您推荐的 Pro 与 Business 订阅可获得 30% 分成',
    recurring: '最长可享每位客户订阅周期的 12 个月持续佣金',
    payouts: '佣金每月通过 Stripe 自动结算',
    dashboard: '实时仪表盘：点击、试用、转化与收益一目了然',
    exampleTitle: '收益示例',
    example1: '10 个 Pro 用户 × $29 × 30% = $87 / 月',
    example2: '10 个 Business 用户 × $99 × 30% = $297 / 月',
    exampleTotal: '合计即',
    exampleRecurring: '仅 20 个活跃用户即可获得的月度持续收益',
  },
  tiers: {
    title: '联系我们',
    affiliate: {
      name: '推广合伙人',
      price: '',
      description: '适合希望向自己受众分享 VGOT 的内容创作者与影响者。',
      cta: '申请成为推广合伙人',
      features: [
        '推荐订阅获得 30% 分成',
        '专属推荐链接',
        '获取营销素材（横幅、脚本示例、演示视频）',
        '合作伙伴邮箱支持',
        '实时跟踪仪表盘',
      ],
    },
    leader: {
      name: '领袖合伙人',
      price: '起价 $99',
      description: '为机构、教育者与社区负责人提供高级支持的高级层级。',
      cta: '申请成为领袖合伙人',
      features: [
        '包含推广合伙人全部权益',
        '更高优先级支持与私有合作频道',
        '联合品牌落地页与案例展示',
        '新功能与活动优先体验',
        '与 VGOT 团队联合举办直播 / 研讨会',
        '顶级表现合作伙伴可获定制方案',
      ],
    },
    customDeals: '顶级合伙人可获得定制方案与更高分成。',
  },
  howItWorks: {
    title: '运作方式',
    step1: { title: '申请', description: '填写一个简短表格，介绍您的受众与使用场景。' },
    step2: { title: '获取专属链接', description: '审核通过后，您将获得唯一推荐链接及合作资源访问权限。' },
    step3: { title: '分享与赚取', description: '向您的社区分享 VGOT。通过您的链接产生的每个付费订阅都为您带来 30% 持续佣金，并由 Stripe 发放。' },
  },
  whyPromote: {
    title: '为什么合作伙伴乐于推广 VGOT',
    highConverting: '高转化产品：从脚本到 HyperSell 视频的一体化工作流',
    clearPricing: '清晰定价：您的受众易于理解的套餐结构',
    educationFriendly: '友好教学：适合教程、工作坊与课程',
    global: '全球适用：服务跨市场的品牌与创作者',
    realPartnership: '真正合作：我们帮助您设计挑战赛、发布与活动',
    recurring: '30% 持续佣金：不仅是首单，持续订阅皆有收益',
  },
  faq: {
    title: '合作伙伴常见问题',
    q1: { question: '加入需要付费吗？', answer: '不需要。标准的推广合伙人层级免费。若您申请高级领袖合伙人并享受额外支持与联合营销，我们可能收取一次性上手费用。' },
    q2: { question: '我能从每位客户获得佣金多久？', answer: '您可在其首次付款起的最长 12 个月内，获得其 Pro 或 Business 计划的 30% 分成。' },
    q3: { question: '结算方式是什么？', answer: '我们使用 Stripe 自动结算。首次连接您的 Stripe 账户后，只要佣金达到条件就会按月发放。' },
    q4: { question: '我自己使用 VGOT 还能成为合作伙伴吗？', answer: '当然。我们最成功的许多合作伙伴本身也是 VGOT 的深度用户。' },
    q5: { question: '是否有最低提现门槛？', answer: '您可以在合作伙伴仪表盘设置最低结算门槛（例如 $50）。达到后 Stripe 将自动处理您的结算。' },
  },
};

// Chinese Traditional - reuse English base then override localized sections
const zhTW = {
  ...en,
  hero: {
    title: '推廣 VGOT 獲得 30% 循環分佣',
    subtitle: '向您的受眾、客戶或學員分享 VGOT，用戶每次訂閱您都可獲得佣金。',
    apply: '申請成為合作夥伴',
    downloadGuide: '下載合作指南',
    payouts: 'Stripe 結算，透明追蹤，每月自動撥款。',
  },
  intro: {
    heading: '加入 VGOT 合作夥伴計劃',
    subheading: '與您的社群分享 VGOT。透過您的連結的每個付費訂閱皆可為您帶來 30% 循環佣金，並由 Stripe 安全結算。',
    cards: {
      highCommission: {
        title: '高額循環分佣',
        description: '不只首次訂閱。用戶保持訂閱的每個月，您都可獲得 30% 分成。',
      },
      stripeSettlement: {
        title: 'Stripe 自動結算',
        description: '我們替您處理 Stripe Connect，佣金直接匯入您的銀行帳戶，透明省心。',
      },
      marketingResources: {
        title: '專屬行銷資源',
        description: '取得官方示範影片、橫幅與文案範本，輕鬆推廣提升轉化。',
      },
    },
    cta: {
      title: '準備好開始賺錢了嗎？',
      description: '告訴我們您的受眾類型。提交後 24 小時內審核並發送 Stripe 邀請。',
      applyButton: '申請成為合作夥伴',
      contactSupport: '聯絡支援團隊',
    },
  },
  whoIsThisFor: {
    title: '非常適合創作者、機構與社群領袖',
    creators: '教授 HyperSell 或 AI 影片的 TikTok / 社群媒體創作者',
    agencies: '管理多家電商店鋪的機構與 MCN',
    educators: '營運訓練營或系列課程的課程創作者與導師',
    communities: '擁有活躍 Discord / WhatsApp / Telegram 社群的社群領袖',
  },
  earning: {
    title: '您在 VGOT 合作夥伴計劃中的收益方式',
    revenue: '每個您推薦的 Pro 與 Business 訂閱可獲得 30% 分成',
    recurring: '最長可享每位客戶訂閱週期的 12 個月循環佣金',
    payouts: '佣金每月經由 Stripe 自動結算',
    dashboard: '即時儀表板：點擊、試用、轉化與收益一目了然',
    exampleTitle: '收益示例',
    example1: '10 個 Pro 用戶 × $29 × 30% = $87 / 月',
    example2: '10 個 Business 用戶 × $99 × 30% = $297 / 月',
    exampleTotal: '合計即',
    exampleRecurring: '僅 20 個活躍用戶即可獲得的月度循環收益',
  },
  tiers: {
    title: '聯絡我們',
    affiliate: {
      name: '推廣夥伴',
      price: '',
      description: '適合希望向自己受眾分享 VGOT 的內容創作者與影響者。',
      cta: '申請成為推廣夥伴',
      features: [
        '推薦訂閱獲得 30% 分成',
        '專屬推薦連結',
        '取得行銷素材（橫幅、腳本示例、示範影片）',
        '合作夥伴 Email 支援',
        '即時追蹤儀表板',
      ],
    },
    leader: {
      name: '領袖夥伴',
      price: '起價 $99',
      description: '為機構、教育者與社群領袖提供進階支援的高級層級。',
      cta: '申請成為領袖夥伴',
      features: [
        '包含推廣夥伴全部權益',
        '更高優先級支援與私有合作頻道',
        '聯合品牌登陸頁與案例展示',
        '新功能與活動優先體驗',
        '與 VGOT 團隊聯合舉辦直播 / 研討會',
        '頂級表現合作夥伴可獲客製方案',
      ],
    },
    customDeals: '頂級夥伴可獲得客製方案與更高分成。',
  },
  howItWorks: {
    title: '運作方式',
    step1: { title: '申請', description: '填寫一個簡短表格，介紹您的受眾與使用場景。' },
    step2: { title: '取得專屬連結', description: '審核通過後，您將獲得唯一推薦連結及合作資源存取權限。' },
    step3: { title: '分享與賺取', description: '向您的社群分享 VGOT。透過您的連結產生的每個付費訂閱都為您帶來 30% 循環佣金，並由 Stripe 發放。' },
  },
  whyPromote: {
    title: '為什麼夥伴樂於推廣 VGOT',
    highConverting: '高轉化產品：從腳本到 HyperSell 影片的一體化工作流程',
    clearPricing: '清晰定價：您的受眾容易理解的方案結構',
    educationFriendly: '教學友好：適合教學、工作坊與課程',
    global: '全球適用：服務跨市場的品牌與創作者',
    realPartnership: '真正合作：我們協助您設計挑戰賽、發佈與活動',
    recurring: '30% 循環佣金：不僅是首單，持續訂閱皆有收益',
  },
  faq: {
    title: '合作夥伴常見問題',
    q1: { question: '加入需要付費嗎？', answer: '不需要。標準的推廣夥伴層級免費。若您申請高級領袖夥伴並享受額外支援與聯合行銷，我們可能收取一次性啟動費。' },
    q2: { question: '我能從每位客戶獲得佣金多久？', answer: '您可在其首次付款起的最長 12 個月內，獲得其 Pro 或 Business 方案的 30% 分成。' },
    q3: { question: '結算方式是什麼？', answer: '我們使用 Stripe 自動結算。首次連接您的 Stripe 帳戶後，只要佣金達到條件就會按月發放。' },
    q4: { question: '我自己使用 VGOT 還能成為合作夥伴嗎？', answer: '當然。許多最成功的合作夥伴本身也是 VGOT 的深度使用者。' },
    q5: { question: '是否有最低提現門檻？', answer: '您可以在合作夥伴儀表板設定最低結算門檻（例如 $50）。達到後 Stripe 會自動處理您的結算。' },
  },
};

// Japanese
const ja = {
  hero: {
    title: 'VGOTで30%の継続収益を獲得',
    subtitle: 'コミュニティやクライアント、受講生にVGOTを紹介し、彼らが購読するたびにコミッションを獲得。',
    apply: 'パートナーに応募',
    downloadGuide: 'パートナーガイドをダウンロード',
    payouts: 'Stripeで自動支払い。透明なトラッキングと毎月の振込。',
  },
  intro: {
    heading: 'VGOT パートナープログラムに参加',
    subheading: 'あなたのコミュニティにVGOTを共有しましょう。あなたのリンクからの有料購読ごとに、Stripeで安全に支払われる30%の継続コミッションを獲得できます。',
    cards: {
      highCommission: {
        title: '高い継続コミッション',
        description: '初回だけではありません。ユーザーが購読を継続する限り、毎月30%を獲得できます。',
      },
      stripeSettlement: {
        title: 'Stripe自動支払い',
        description: 'Stripe Connectの接続から振込までを当社が対応。銀行口座へ透明かつ手間いらずで入金します。',
      },
      marketingResources: {
        title: '独自のマーケ素材',
        description: '公式デモ動画、バナー、コピーのテンプレートをご提供。プロモーションとCVR向上を支援します。',
      },
    },
    cta: {
      title: '今すぐ収益化を始めましょう',
      description: 'あなたのオーディエンスについて簡単に教えてください。申請後、24時間以内に審査し、Stripe招待をお送りします。',
      applyButton: 'パートナーに応募',
      contactSupport: 'サポートに連絡',
    },
  },
  whoIsThisFor: {
    title: 'クリエイター・代理店・コミュニティ運営者に最適',
    creators: 'HyperSellやAI動画を教えるTikTok/各種SNSのクリエイター',
    agencies: '複数のECストアを運用する代理店・MCN',
    educators: 'ブートキャンプや講座を運営する講師・教育者',
    communities: 'Discord/WhatsApp/Telegramなどアクティブなコミュニティ運営者',
  },
  earning: {
    title: 'VGOT パートナープログラムでの収益化の仕組み',
    revenue: '紹介したPro/Businessプランの購読に対して30%を分配',
    recurring: '各顧客の購読開始から最大12か月間、継続的に発生',
    payouts: '毎月Stripeで自動振込',
    dashboard: 'クリック・トライアル・コンバージョン・売上をリアルタイムで可視化',
    exampleTitle: '収益例',
    example1: 'Proユーザー10人 × $29 × 30% = $87 / 月',
    example2: 'Businessユーザー10人 × $99 × 30% = $297 / 月',
    exampleTotal: '合計で',
    exampleRecurring: 'わずか20人のアクティブユーザーで得られる毎月の継続収益',
  },
  tiers: {
    title: 'お問い合わせ',
    affiliate: {
      name: 'アフィリエイトパートナー',
      price: '',
      description: '自身のオーディエンスにVGOTを紹介したいインフルエンサーやクリエイターに最適。',
      cta: 'アフィリエイトパートナーに応募',
      features: [
        '紹介購読に対して30%の収益分配',
        '個別のリファラルリンク',
        'マーケ素材（バナー、サンプル台本、デモ動画）へのアクセス',
        'メールによるパートナーサポート',
        'リアルタイムのトラッキングダッシュボード',
      ],
    },
    leader: {
      name: 'リーダーパートナー',
      price: '月$99〜',
      description: '代理店・教育者・コミュニティ運営者向けの上位プラン。専任サポート付き。',
      cta: 'リーダーとして応募',
      features: [
        'アフィリエイトの全特典を含む',
        '高優先のサポートと専用パートナーチャンネル',
        '共同ブランドのLPや導入事例',
        '新機能・キャンペーンへの先行アクセス',
        'VGOTチームとの共同ウェビナー/ライブ',
        '高実績パートナー向けのカスタムオファー',
      ],
    },
    customDeals: '上位パートナーにはカスタム条件や更なる分配率をご用意します。',
  },
  howItWorks: {
    title: '進め方',
    step1: { title: '応募', description: 'あなたのオーディエンスやユースケースについて簡単に入力。' },
    step2: { title: 'リンクの発行', description: '承認後、専用の紹介リンクとパートナーリソースを提供します。' },
    step3: { title: '共有して収益化', description: 'コミュニティでVGOTを共有。あなたのリンクからの有料購読ごとに30%の継続コミッションがStripeで支払われます。' },
  },
  whyPromote: {
    title: 'パートナーがVGOTを薦める理由',
    highConverting: '高コンバージョンの製品：台本からHyperSell動画までの一気通貫ワークフロー',
    clearPricing: '明確な料金体系で、オーディエンスにも分かりやすい',
    educationFriendly: '教育用途に最適：チュートリアル、ワークショップ、講座にフィット',
    global: 'グローバル対応：あらゆる市場のブランド/クリエイターで活用可能',
    realPartnership: '本物のパートナーシップ：チャレンジやローンチ、キャンペーン設計を支援',
    recurring: '30%の継続収益：初回だけでなく更新からも収益化',
  },
  faq: {
    title: 'よくある質問（パートナー）',
    q1: { question: '参加に費用はかかりますか？', answer: 'いいえ。標準のアフィリエイトパートナーは無料です。上位のリーダーパートナー（追加サポートや共同マーケ付き）の場合、初期費用をいただくことがあります。' },
    q2: { question: '各顧客からどのくらいの期間コミッションを得られますか？', answer: '初回決済から最大12か月間、その顧客のProまたはBusinessプラン料金の30%を獲得できます。' },
    q3: { question: '支払いの仕組みは？', answer: 'Stripeによる自動支払いです。最初にStripeアカウントを連携すれば、条件を満たした月に自動で振込されます。' },
    q4: { question: '自分でもVGOTを使いながら参加できますか？', answer: 'もちろんです。多くの優秀なパートナーはVGOTのヘビーユーザーでもあります。' },
    q5: { question: '最低支払額の条件はありますか？', answer: 'パートナーダッシュボードで最低支払額（例：$50）を設定できます。到達するとStripeが自動的に処理します。' },
  },
};

export const partnerTranslations = { en, es, 'zh-CN': zhCN, 'zh-TW': zhTW, ja };
